import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';
import { Link } from 'react-router';

export const StyledLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    min-width: auto;
    width: 100%;
    font-size: ${({ theme }) => theme.fontSizes[4]};
    padding: ${({ theme }) => theme.space[4]} ${({ theme }) => theme.space[5]};
    border: 1px solid ${({ theme }) => theme.colors.blue__secondary__70}!important;
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.medium};
    line-height: ${({ theme }) => theme.lineHeights.input};
    color: ${({ theme }) => theme.colors.button.primary.solid.text};
    background-color: ${({ theme }) => theme.colors.button.primary.solid.background};
    text-align: center;
    text-decoration: none;

    &:hover {
        color: ${({ theme }) => theme.colors.button.secondary.outline.hover.text};
        border: 2px solid ${({ theme }) => theme.colors.button.secondary.outline.hover.border};
        background-color: ${({ theme }) => theme.colors.button.secondary.outline.hover.background};
    }

    &:focus,
    &:active {
        color: ${({ theme }) => theme.colors.button.secondary.outline.focus.text};
        border: 2px solid ${({ theme }) => theme.colors.button.secondary.outline.focus.border};
        background-color: ${({ theme }) => theme.colors.button.secondary.outline.focus.background};
    }

    &:focus-visible {
        border: ${({ theme }) => theme.borders[2]} ${({ theme }) => theme.colors.blacks[11]};
        outline: ${({ theme }) => theme.borders[3]} ${({ theme }) => theme.colors.aqua__80};
    }

    ${breakpointUp.md`
        width:auto;
    `}
`;
